<script setup lang="tsx">
import { useI18n } from 'vue-i18n'
import { Tabs } from '@/types/module'
import { ref, watch } from 'vue'

const props = defineProps<{
	override?: Tabs
}>()

const localTab = ref<Tabs>(props.override ?? Tabs.Module)
const emit = defineEmits<{ (e: 'update:override', value: Tabs): void }>()

watch(
	() => props.override,
	(newVal) => {
		if (newVal) localTab.value = newVal
	},
)

function selectTab(tab: Tabs) {
	if (localTab.value !== tab) {
		localTab.value = tab
		emit('update:override', tab)
	}
}

const { t } = useI18n()
</script>

<template>
	<ul class="nav nav-tabs mb-3" id="module-tabs" role="tablist">
		<li class="nav-item" role="presentation">
			<button
				:class="['nav-link', { active: localTab === Tabs.Module }]"
				id="module-tab"
				data-test="module-tab"
				data-bs-toggle="tab"
				data-bs-target="#module-tab-pane"
				type="button"
				role="tab"
				@click="selectTab(Tabs.Module)"
			>
				{{ t('module.label') }}
			</button>
		</li>
		<li class="nav-item" role="presentation">
			<button
				:class="['nav-link', { active: localTab === Tabs.Measures }]"
				id="measures-tab"
				data-test="measures-tab"
				data-bs-toggle="tab"
				data-bs-target="#measures-tab-pane"
				type="button"
				role="tab"
				@click="selectTab(Tabs.Measures)"
			>
				{{ t('measure', 2) }}
			</button>
		</li>
	</ul>

	<div class="tab-content" id="tabs-content">
		<div
			class="tab-pane fade"
			:class="{ show: localTab === Tabs.Module, active: localTab === Tabs.Module }"
			id="module-tab-pane"
			role="tabpanel"
			aria-labelledby="module-tab"
			tabindex="0"
		>
			<slot name="module" />
		</div>
		<div
			class="tab-pane fade"
			:class="{ show: localTab === Tabs.Measures, active: localTab === Tabs.Measures }"
			id="measures-tab-pane"
			role="tabpanel"
			aria-labelledby="measures-tab"
		>
			<slot name="measures" />
		</div>
	</div>
</template>
